import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import getComplectations from '../../api/cars/getComplectations';
import createComplectation from '../../api/cars/createComplectation';
import Select from '../Select/Select';
import DictionaryNameModal from '../Modal/DictionaryNameModal';
import useDictionaryCreator from './useDictionaryCreator';

/**
 * @param {boolean} used â Ð±/Ñ-Ð¿ÑÐ¾ÑÐµÑÑ: Ð¾Ð±ÑÑÐ½ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð¿Ð»ÑÑ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð¿Ð¾Ð´
 * Ð±/Ñ, Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½Ð¾Ð²ÑÑ Ð¿ÑÑÐ¼Ð¾ Ð·Ð´ÐµÑÑ.
 */
const SelectComplectations = ({
  handleSetSelect,
  handleSetState,
  style,
  params,
  dependantValue,
  dependencyAccessor = (obj) => obj,
  used,
  creatable,
  ...props
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const isFirstRun = useRef(true);
  // Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð¾ÑÐºÑÑÐ»Ð¸ ÑÐ°Ð½ÑÑÐµ, ÑÐµÐ¼ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸Ð»ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ: onFocus Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ ÑÑÐ°Ð±Ð¾ÑÐ°ÐµÑ,
  // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð·Ð°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÐ¼ Ð½Ð°Ð¼ÐµÑÐµÐ½Ð¸Ðµ Ð¸ Ð´Ð¾Ð³ÑÑÐ¶Ð°ÐµÐ¼, ÐºÐ¾Ð³Ð´Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿ÑÐ¸ÐµÐ´ÐµÑ.
  const awaitingContainer = useRef(false);
  // ÐÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ, Ð´Ð»Ñ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ¶Ðµ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð»Ð¸.
  const loadedFor = useRef(null);
  const depKey = useMemo(() => dependencyAccessor(dependantValue), [dependantValue, dependencyAccessor]);

  // params Ð±ÑÐ²Ð°ÐµÑ Ð¸ Ð½Ðµ Ð¿ÐµÑÐµÐ´Ð°Ð½ (ÑÐ¼. Form.jsx), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð·Ð¾Ð²ÑÐ¼ ÐµÐ³Ð¾ ÑÐµÑÐµÐ· Ð¿ÑÐ¾Ð²ÐµÑÐºÑ.
  const containerId = params ? params() : null;

  const load = useCallback(
    (id) => {
      // Â«Ð£Ð¶Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾Â» ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÑ, Ð° Ð½Ðµ Ð¿Ð¾ Ð´Ð»Ð¸Ð½Ðµ ÑÐ¿Ð¸ÑÐºÐ°: Ñ Ð½Ð¾Ð²Ð¾Ð³Ð¾
      // ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ Ð½Ð¾Ð»Ñ, Ð¸ Ð¿ÑÐ¸Ð·Ð½Ð°Ðº data.length > 0 Ð½Ðµ ÑÑÐ°Ð±Ð°ÑÑÐ²Ð°Ð»
      // Ð½Ð¸ÐºÐ¾Ð³Ð´Ð°. Select Ð´ÑÑÐ³Ð°ÐµÑ onFocus ÐµÑÑ Ð¸ ÐºÐ°Ðº onScrollToBottom Ð¿Ð¾ÑÐ»Ðµ ÐºÐ°Ð¶Ð´Ð¾Ð¹
      // Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÑÑÐ¾Ð¹ Ð¾ÑÐ²ÐµÑ ÑÑÐ¾Ð´Ð¸Ð» Ð² Ð±ÐµÑÐºÐ¾Ð½ÐµÑÐ½ÑÐ¹ ÑÐ¸ÐºÐ» Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð².
      if (loadedFor.current === id) return;
      loadedFor.current = id;
      setLoading(true);
      getComplectations({ containerId: id, used: used || undefined })
        .then((res) => {
          const complectations = res.data.map((item) => {
            return { value: item.id, label: item.title };
          });
          setData(complectations);
        })
        .catch(() => {
          // ÐÐ°ÑÑ ÑÐ°Ð½Ñ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿ÑÐ¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼ Ð¾ÑÐºÑÑÑÐ¸Ð¸ ÑÐ¿Ð¸ÑÐºÐ°.
          loadedFor.current = null;
        })
        .finally(() => setLoading(false));
    },
    [used]
  );

  const onFocus = useCallback(() => {
    if (loading) return;
    if (!containerId) {
      awaitingContainer.current = true;
      return;
    }
    load(containerId);
  }, [containerId, loading, load]);

  // ÐÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿ÑÐ¸ÐµÐ·Ð¶Ð°ÐµÑ Ð°ÑÐ¸Ð½ÑÑÐ¾Ð½Ð½Ð¾ (ensureContainer Ð¿Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð¾Ð´ÐµÐ»Ð¸). ÐÑÐ»Ð¸
  // Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¾ÑÐºÑÑÐ» ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð±ÑÑÑÑÐµÐµ Ð¾ÑÐ²ÐµÑÐ°, ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ°Ðº Ð¸ Ð¾ÑÑÐ°Ð²Ð°Ð»ÑÑ Ð¿ÑÑÑÑÐ¼
  // Ð´Ð¾ Ð¿ÐµÑÐµÐ¾ÑÐºÑÑÑÐ¸Ñ ÑÐµÐ»ÐµÐºÑÐ°.
  useEffect(() => {
    if (!containerId || !awaitingContainer.current) return;
    awaitingContainer.current = false;
    load(containerId);
  }, [containerId, load]);

  const create = useCallback(
    async (name) => {
      const containerId = params();
      if (!containerId) throw new Error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ');
      // Ð¥Ð°ÑÐ°ÐºÑÐµÑÐ¸ÑÑÐ¸ÐºÐ¸ (Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ, Ð¿ÑÐ¸Ð²Ð¾Ð´, ÐºÑÐ·Ð¾Ð²) Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÐµÑ Ð½Ð° ÑÐ°Ð¼Ð¾Ð¹
      // Ð¼Ð°ÑÐ¸Ð½Ðµ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ ÑÐ²Ð°ÑÐ°ÐµÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ â Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð´ÐµÑÐ¾Ð»ÑÑ, ÐºÐ°Ðº
      // Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ /cars/complectations/create.
      const res = await createComplectation({
        title: name,
        containerId,
        used: !!used,
        engineId: 1,
        carcaseId: 1,
        wdId: 2,
      });
      const id = Number(res?.data);
      if (!id) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ');
      return { value: id, label: name };
    },
    [params, used]
  );

  const { extraOptions, selectProps, modalProps } = useDictionaryCreator({
    // ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð²ÐµÑÐ°ÐµÑÑÑ Ð½Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ (Ð¼Ð°ÑÐºÐ°+Ð¼Ð¾Ð´ÐµÐ»Ñ) â Ð±ÐµÐ· Ð½ÐµÐ³Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð½ÐµÑ.
    enabled: Boolean((creatable ?? used) && containerId),
    kind: 'complectation',
    create,
    onChange: props?.onChange,
    onChangeCustom: props?.onChangeCustom,
    resetKey: depKey,
    // dependantValue â [Ð¼Ð°ÑÐºÐ°, Ð¼Ð¾Ð´ÐµÐ»Ñ], ÑÐ¼. dependency Ð² carInfoInputs.
    context: depKey
      ? `ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ: ${[].concat(dependantValue || []).map((o) => o?.label).filter(Boolean).join(' ')}`
      : undefined,
  });

  const options = useMemo(() => [...extraOptions, ...data], [extraOptions, data]);

  useEffect(() => {
    setData([]);
    awaitingContainer.current = false;
    loadedFor.current = null;
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (props?.onChange) {
      props.onChange(null);
    }
  }, [depKey])
  return (
    <>
      <Select
        handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
        handleSetState={handleSetState}
        options={options}
        title={'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ'}
        placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
        onFocus={onFocus}
        style={style}
        isLoading={loading}
        {...props}
        {...selectProps}
      />
      {selectProps && <DictionaryNameModal {...modalProps} />}
    </>
  );
};

export default SelectComplectations;
